import { Field } from '@atlaskit/form';
import MultiStepDragAndDrop from './MultiStepDragAndDrop';
import { jsx as _jsx } from "react/jsx-runtime";
const MultiStepDragAndDropContainer = props => {
  const {
    label,
    name,
    value,
    addNewRecordLabel,
    content
  } = props;
  return /*#__PURE__*/_jsx(Field, {
    name: name,
    defaultValue: value,
    children: _ref => {
      let {
        fieldProps
      } = _ref;
      return /*#__PURE__*/_jsx(MultiStepDragAndDrop, {
        fieldProps: fieldProps,
        label: label,
        addNewRecordLabel: addNewRecordLabel,
        content: content
      });
    }
  });
};
export default MultiStepDragAndDropContainer;